import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import useStyles from './styles';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';
import { useDispatch } from 'react-redux';
import * as NavigationSelectors from 'redux/reducers/gl_navigation_reducer/selectors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Searchbar from 'components/atoms/Searchbar';
import BaseNavigationMenu from 'components/app_common/BaseNavigationMenu';
import { Box, Typography } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import NavigationConfig from 'navigation/config';
import { TranslationKey } from '../configuration';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import Badge from '@material-ui/core/Badge';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import { useHostDetails } from 'redux/reducers/gl_host_provider/selectors';
import RegisterOrLoginMenu from './RegisterOrLoginMenu';
import * as CommonSelector from 'redux/reducers/gl_common_reducer/selectors';
import { SearchButton } from '../Actions';
import useMobile from 'hooks/useMobile';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const anchor: Anchor = 'left';

const UserDrawer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const visible = NavigationSelectors.useUserMenuVisiblity();

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      dispatch(NavigationActions.showUserMenuAction({ visible: open }));
    };

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <MenuSelector />
    </div>
  );

  return (
    <Drawer
      anchor={anchor}
      open={visible}
      onClose={toggleDrawer(anchor, false)}
      PaperProps={{ style: { height: '100%' } }}
    >
      {list(anchor)}
    </Drawer>
  );
};

const UserMenu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const interest = CommonSelector.useInterest().data;
  const host = useHostDetails();
  const isMobile = useMobile();

  const SEARCH_MENU = [
    {
      id: 'myFavorites',
      label: (
        <TranslatedTextV2
          defaultText="My Favorites"
          translationKey={`${TranslationKey}.myFavorites`}
        />
      ),
      icon: (
        <Badge badgeContent={interest?.favourites || 0} color="error">
          <FavoriteBorderOutlinedIcon />
        </Badge>
      ),
      path: NavigationConfig.clientAccountFavoritesPage().path,
      //iconRight: <Badge badgeContent={4} color="secondary" />,
      onClick: () => {
        dispatch(NavigationActions.showUserMenuAction({ visible: false }));
      },
    },
    {
      id: 'savedSearches',
      label: (
        <TranslatedTextV2
          defaultText="Saved Searches"
          translationKey={`${TranslationKey}.savedSearches`}
        />
      ),
      path: NavigationConfig.clientAccountSavedSearchesPage().path,
      icon: (
        <Badge badgeContent={interest?.savedSearch || 0} color="error">
          <SearchOutlinedIcon />
        </Badge>
      ),
      // iconRight: <Badge badgeContent={4} color="secondary" />,
      onClick: () => {
        dispatch(NavigationActions.showUserMenuAction({ visible: false }));
      },
    },
  ];

  const BLOGMENU = [
    {
      id: 'blog',
      path: NavigationConfig.showBlogPage().path,
      label: (
        <TranslatedTextV2
          defaultText="BLOG"
          translationKey={`${TranslationKey}.blog`}
        />
      ),
      onClick: () => {
        dispatch(NavigationActions.showUserMenuAction({ visible: false }));
      },
    },
  ];

  const NEWMENU = [
    {
      id: 'news',
      path: NavigationConfig.showNewsPage().path,
      label: (
        <TranslatedTextV2
          defaultText="NEWS"
          translationKey={`${TranslationKey}.news`}
        />
      ),
      onClick: () => {
        dispatch(NavigationActions.showUserMenuAction({ visible: false }));
      },
    },
  ];

  return (
    <BaseNavigationMenu
      containerProps={{ style: { padding: '1rem' } }}
      Header={
        <div
          className={classes.navIconShowDesktop}
          style={{ marginBottom: '1rem' }}
        >
          <SearchButton fullwidthMode />
        </div>
      }
      Footer={
        <>
          <Divider />
          <div style={{ padding: '1rem' }}>
            <Typography>{'© Finer 2023'}</Typography>
            {/* <Typography>{'Privacy Policy / Cookie Policy'}</Typography> */}
          </div>
        </>
      }
      menuContainer={[
        {
          Header: (
            <Typography className={classes.submenuTitle}>
              <TranslatedTextV2
                defaultText="MENU"
                translationKey={`${TranslationKey}.menu`}
              />
            </Typography>
          ),
          menu: [
            {
              id: 'home',
              path: NavigationConfig.homePage().path,
              label: (
                <TranslatedTextV2
                  defaultText="HOME"
                  translationKey={`${TranslationKey}.home`}
                />
              ),
              onClick: () => {
                dispatch(
                  NavigationActions.showUserMenuAction({ visible: false })
                );
              },
            },
            ...(!isMobile
              ? [
                  {
                    id: 'game',
                    path: NavigationConfig.gameScenePage().path,
                    label: (
                      <TranslatedTextV2
                        defaultText="GAME"
                        translationKey={`${TranslationKey}.game`}
                      />
                    ),
                    onClick: () => {
                      dispatch(
                        NavigationActions.showUserMenuAction({ visible: false })
                      );
                    },
                  },
                ]
              : []),
            // {
            //   id: 'properties',
            //   path: NavigationConfig.productsPage().path,
            //   label: (
            //     <TranslatedTextV2
            //       defaultText="CORNERS"
            //       translationKey={`${TranslationKey}.properties`}
            //     />
            //   ),
            //   onClick: () => {
            //     dispatch(
            //       NavigationActions.showUserMenuAction({ visible: false })
            //     );
            //   },
            // },
            ...(host.data?.settings['cellock.general.blog'] === '1'
              ? BLOGMENU
              : []),
            ...(host.data?.settings['cellock.general.news'] === '1'
              ? NEWMENU
              : []),
            /*{
              id: 'contact',
              // path: NavigationConfig.homePage().path,
              label: (
                <TranslatedTextV2
                  defaultText="CONTACT"
                  translationKey={`${TranslationKey}.contact`}
                />
              ),
              onClick: () => {
                dispatch(
                  NavigationActions.showUserMenuAction({ visible: false })
                );
              },
            },*/
          ],
        },
        {
          Header: (
            <Typography className={classes.submenuTitle}>
              <TranslatedTextV2
                defaultText="MY PROFILE"
                translationKey={`${TranslationKey}.myProfile`}
              />
            </Typography>
          ),
          menu: [
            {
              id: 'myAccount',
              path: NavigationConfig.clientAccountProfilePage().path,
              label: (
                <TranslatedTextV2
                  defaultText="My Account"
                  translationKey={`${TranslationKey}.myAccount`}
                />
              ),
              icon: <PersonOutlinedIcon />,
              onClick: () => {
                dispatch(
                  NavigationActions.showUserMenuAction({ visible: false })
                );
              },
            },
            ...(host.data?.settings['cellock.general.shop'] === '1'
              ? SEARCH_MENU
              : []),
            // {
            //   id: 'myFavorites',
            //   label: (
            //     <TranslatedTextV2
            //       defaultText="My Favorites"
            //       translationKey={`${TranslationKey}.myFavorites`}
            //     />
            //   ),
            //   icon: (
            //     <Badge badgeContent={interest?.favourites || 0} color="error">
            //       <FavoriteBorderOutlinedIcon />
            //     </Badge>
            //   ),
            //   path: NavigationConfig.clientAccountFavoritesPage().path,
            //   //iconRight: <Badge badgeContent={4} color="secondary" />,
            //   onClick: () => {
            //     dispatch(
            //       NavigationActions.showUserMenuAction({ visible: false })
            //     );
            //   },
            // },
            // {
            //   id: 'savedSearches',
            //   label: (
            //     <TranslatedTextV2
            //       defaultText="Saved Searches"
            //       translationKey={`${TranslationKey}.savedSearches`}
            //     />
            //   ),
            //   path: NavigationConfig.clientAccountSavedSearchesPage().path,
            //   icon: (
            //     <Badge badgeContent={interest?.savedSearch || 0} color="error">
            //       <SearchOutlinedIcon />
            //     </Badge>
            //   ),
            //   // iconRight: <Badge badgeContent={4} color="secondary" />,
            //   onClick: () => {
            //     dispatch(
            //       NavigationActions.showUserMenuAction({ visible: false })
            //     );
            //   },
            // },
            /*{
              id: 'recommendations',
              label: (
                <TranslatedTextV2
                  defaultText="Recommendations"
                  translationKey={`${TranslationKey}.recommendations`}
                />
              ),
              path: NavigationConfig.clientAccountRecommendationPage().path,
              onClick: () => {
                dispatch(
                  NavigationActions.showUserMenuAction({ visible: false })
                );
              },
              icon: <HomeOutlinedIcon />,
            },*/
          ],
        },
      ]}
    />
  );
};

const MenuSelector = () => {
  const isLogin = AuthSelectors.useLogin();
  const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <Box style={{ width: '100%' }} display="flex" flexDirection="column">
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={() =>
            dispatch(NavigationActions.showUserMenuAction({ visible: false }))
          }
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Box
        style={{
          alignSelf: 'center',
          display: 'flex',
          flex: 1,
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          {!isLogin ? <RegisterOrLoginMenu /> : <UserMenu />}
        </div>
      </Box>
    </Box>
  );
};

export default UserDrawer;
